var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$s.TermsGeneratorContainer},[_c('terms-generator-page',{attrs:{"page-data":_vm.$store.state.pageContent,"terms-properties":_vm.termsProperties}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }